/* @flow weak */
import { datePopups as popups } from 'react-widgets/lib/util/constants';
import { DateTimePicker as ReactDateTimePicker } from 'lib/ReactWidgets';
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import InputConstants from 'constants/InputConstants';
import PropTypes from 'prop-types';
import * as React from 'react';

import withDateTimePickerPosition from 'components/lib/withDateTimePickerPosition';

import './styles/TimePickerInput.scss';

/**
 * ## Time input wrapping a [React Widget](https://jquense.github.io/react-widgets/docs/#/datetime-picker).
 *
 *
 * ```example
 * <TimePickerInput />
 * ```
 *
 *
 * # TODO
 * * Reconcile children & styles with [DatePickerInput](/internal/components/DatePickerInput)
 */

class TimePickerInput extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    /** Native */
    disabled: PropTypes.bool,
    /** Latest time */
    max: PropTypes.instanceOf(Date),
    /** Earliest time */
    min: PropTypes.instanceOf(Date),
    /** Native */
    placeholder: PropTypes.string,
    /** Native */
    value: PropTypes.instanceOf(Date),
    className: PropTypes.string,
    'data-test': PropTypes.string,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onPickerClick: PropTypes.func.isRequired,
    closePopup: PropTypes.func.isRequired,
    focused: PropTypes.bool,
    opened: PropTypes.bool,
    error: PropTypes.bool,
  };

  handleClick = event => {
    const { disabled, onPickerClick } = this.props;

    if (!disabled) {
      onPickerClick(event);
    }
  };

  render() {
    const {
      className,
      closePopup,
      disabled,
      error,
      focused,
      max,
      min,
      onBlur,
      onChange,
      onFocus,
      opened,
      placeholder,
      value,
    } = this.props;
    const open = opened ? popups.TIME : false;
    const active = focused || opened;

    return (
      <div
        className={cx(
          'TimePickerInput',
          {
            'TimePickerInput--disabled': disabled,
            'TimePickerInput--error': error,
            'TimePickerInput--focused': active,
          },
          className
        )}
        onClick={this.handleClick}>
        <ReactDateTimePicker
          duration={0}
          format="h:mm tt"
          max={max}
          min={min}
          open={open}
          parse={['h:mm tt', 'h:mmtt', 'HH:mm']}
          placeholder={placeholder}
          ref="picker"
          step={5}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          onKeyDown={closePopup}
          onToggle={() => {}}
          data-test={this.props['data-test']}
        />
        <Glyph
          color={active ? InputConstants.ACTIVE_GLYPH_COLOR : InputConstants.GLYPH_COLOR}
          name="clock"
          size={InputConstants.GLYPH_SIZE}
        />
      </div>
    );
  }
}

export default withDateTimePickerPosition(TimePickerInput);
